var _rect, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFrame151(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#ECFDE8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.25 47.5V51",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.917 56.6667H48.5837V55.0001C48.5837 53.1667 47.0837 51.6667 45.2503 51.6667H35.2503C33.417 51.6667 31.917 53.1667 31.917 55.0001V56.6667Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2497 56.6666H50.2497M39.9997 46.6666C33.5497 46.6666 28.333 41.4499 28.333 34.9999V29.9999C28.333 26.3166 31.3163 23.3333 34.9997 23.3333H44.9997C48.683 23.3333 51.6663 26.3166 51.6663 29.9999V34.9999C51.6663 41.4499 46.4497 46.6666 39.9997 46.6666Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1171 39.4167C27.8671 39.0167 26.7671 38.2833 25.9004 37.4167C24.4004 35.75 23.4004 33.75 23.4004 31.4167C23.4004 29.0833 25.2337 27.25 27.5671 27.25H28.6504C28.3171 28.0167 28.1504 28.8667 28.1504 29.75V34.75C28.1504 36.4167 28.5004 37.9833 29.1171 39.4167ZM50.8837 39.4167C52.1337 39.0167 53.2337 38.2833 54.1004 37.4167C55.6004 35.75 56.6004 33.75 56.6004 31.4167C56.6004 29.0833 54.7671 27.25 52.4337 27.25H51.3504C51.6837 28.0167 51.8504 28.8667 51.8504 29.75V34.75C51.8504 36.4167 51.5004 37.9833 50.8837 39.4167Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame151);
export default __webpack_public_path__ + "static/media/Frame 151.de1540393e41d1afeb92f86bd0d589b8.svg";
export { ForwardRef as ReactComponent };